import Vue from 'vue'
import VueI18n from 'vue-i18n'
import constant from '@/constant'
import { pluralizationRules } from '@/utils/language/pluralizationRules'

Vue.use(VueI18n)
const locale = 'en'
const i18n = new VueI18n({
  locale,
  messages: {},
  fallbackLocale: constant.defaultFallbackLocale,
  pluralizationRules,
})
export default i18n
